module.exports = __webpack_public_path__ + "img/no-date.2f303cd5.png";